import React from 'react';
import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import { withStyles } from '@material-ui/core/styles';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import AppWrapper from '../../../Helper/AppWrapper/appWrapper';
import ErrorComponent from '../../../Helper/ErrorComponent/errorComponent';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import PostAppView from './postAppView';
import PostWebView from './postWebView';
import PostEdit from './postEdit';
import {addPost, fetchPost, deletePost,updatePost,EmptyFeedList} from "../../../Actions/postActions";
import {bindActionCreators} from "redux";

const styles={

};

class Posts extends React.Component {
  constructor(props){
    super(props);
    this.state={
      userId:'',
      firstName:'',
      feedId:'',
      latitude:'',
      feedType:'',
      postComment:'',
      longitude:'',
      feedSendType:'',
      jsonObject:{},
      open:true,
      pageNo:1,
      delCount:0,
      errorMessage:'',
      showErrorComponent:false,
      showAlert:false,
      Msg:""
    }
  }

  componentWillMount() {
    let {user} = this.props;
    this.setState({
      userId: user.results.AppUser.UserId,
      latitude: Number(user.results.AppUser.Latitude).toFixed(5).toString(),
      firstName: user.results.AppUser.FirstName,
      feedType:'LocalFeed',
      longitude: Number(user.results.AppUser.Longitude).toFixed(5).toString(),
      feedSendType:'LocalFeed'
    },()=>{this.setInitial()});
  }

  setInitial = () => {
    let {userId,latitude,longitude,pageNo,delCount} = this.state;
    this.props.fetchPost({UserId: userId,Latitude:latitude,Longitude:longitude,pageNo:pageNo,delCount:delCount});
  };

  deletePostFeedId = () => {
    let {feedId,userId} = this.state;
    this.props.deletePost({FeedId: feedId,UserId: userId});
  };

  checkFormat = (url) => {
    let arr = url.split(',');
    return arr[arr.length - 1];
  };

  setDeleteCount=(count)=> {
    let delCount = this.state.delCount + count;
    this.setState({delCount})
  }

  addPostData = (data) => {
    let {userId, latitude, feedType, longitude, feedSendType} = this.state;
    if(data.Picture.length!==0) {
      this.setState({
        jsonObject: {
          'FeedSendType': feedSendType,
          'FeedType': feedType,
          'Image': this.checkFormat(data.Picture),
          'Latitude': latitude,
          'Longitude': longitude,
          'PostComment': data.PostComment,
          'UserId': userId,
          'isImage': 'YES',
          'isVideo': 'NO',
        }
      }, () => {
        this.callApi();
      })
    }
    else {
      this.setState({
        jsonObject: {
          'FeedSendType': feedSendType,
          'FeedType': feedType,
          'Image': '',
          'Latitude': latitude,
          'Longitude': longitude,
          'PostComment': data.PostComment,
          'UserId': userId,
          'isImage': 'NO',
          'isVideo': 'NO',
        }
      }, () => {
        this.callApi();
      })
    }
  };

  callApi = () => {
    let {jsonObject} = this.state;
    this.props.addPost(jsonObject);
  };

  onUpload = (data,message) => {
    message==='Delete' ?
      this.setState({
        feedId: data
      },()=>{
        this.deletePostFeedId();
      })
      :
      this.addPostData(data);
  };

  onScrollEvent=(event)=>{
    const PostApp=event.target;
    let {postData}=this.props;
    let {userId,latitude,longitude,pageNo,delCount} = this.state;
    if(PostApp.scrollHeight - PostApp.scrollTop === PostApp.clientHeight){
      if(pageNo*15<postData.TotalCounts) {
        pageNo = pageNo + 1;
        this.setState({pageNo, delCount}, () => {
          this.props.fetchPost({
            UserId: userId,
            Latitude: latitude,
            Longitude: longitude,
            pageNo: pageNo,
            delCount: delCount
          });
        });
      }
    }
  }

  toggleAlert = () => {
      this.setState({
        showAlert: !this.state.showAlert,
      });
  };

  onUpdate=(updatedPost)=>{
    let {latitude,longitude,feedId,feedType,userId}=this.state;
    this.props.updatePost({
      PostComment:updatedPost,
      Latitude:latitude,
      Longitude:longitude,
      LocationAddress:"",
      FeedType:feedType,
      FeedId:feedId,
      UserId:userId
    }).then(()=>{
      this.toggleAlert();
    }).catch((err)=>{
      console.log(err)
    });
  }
  showAlert=(flag,errmessage)=>this.setState({showErrorComponent:flag,errorMessage:errmessage})

  postEdit=(postComment,feedId)=>{
    if(postComment!=="")
      this.setState({postComment,feedId});
    else
      this.setState({postComment:"image post",feedId});
    //this.props.deletePost({FeedId: feedId,UserId: userId});
  }

  onError=(flag,msg)=>{
      this.setState({
        showErrorComponent:flag,
        errorMesage:msg
      })
  }

  componentWillUnmount(){
    this.props.EmptyFeedList();
  }

  render(){
    const { user } = this.props;
    return(
      <div>
        {
          (this.state.showErrorComponent) && <ErrorComponent clickMethod={this.onError} msg={this.state.errorMessage}/>
        }
        <div className='container-div'>
          <ContentGrid
            header={
              user.results.BusinessUser.isFirstVisit && JSON.parse(user.results.BusinessUser.isFirstVisit)['My Local Posts'] ?
                <RouteHeader title={'My Local Posts'}
                             text={'Create a post that reaches all users within 15 mile radius. Be creative ' +
                             'and have fun!'}
                /> : <span/>
            }
            content={
              <Grid container spacing={24}>
                <Grid item sm={12} xs={12}>
                  <Card content={
                    <PostWebView onUpload={this.onUpload} user={this.props.user} editData={this.state.postComment}
                                 onUpdate={this.onUpdate} showAlert={this.showAlert}/>
                  }/>
                </Grid>
                {this.props.postData.LocalFeedList.length > 0 && <Grid item sm={12} xs={12}>
                  <Card content={
                    <PostEdit
                      postData={this.props.postData}
                      showAlert={this.state.showAlert}
                      onUpload={this.onUpload}
                      scroll={this.onScrollEvent}
                      deleteCount={this.setDeleteCount}
                      onEdit={this.postEdit}
                      toggleAlert={this.toggleAlert}
                    />
                  }/>
                </Grid>}
              </Grid>
            }
            appView={
              <AppWrapper tab={3} header={'Live Preview'}
                          content={
                            <PostAppView postData={this.props.postData} scroll={this.onScrollEvent}/>
                          }
              />
            }
          />
        </div>
      </div>
    )
  }
}
const mapStateToProps=(state)=> {
  return {
    postData:state.post,
    user:state.loginResponse
  }
};
const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addPost, fetchPost, deletePost,updatePost,EmptyFeedList
  }, dispatch)
};
export default withStyles(styles)(connect(mapStateToProps, matchDispatchToProps)(Posts));